import React from 'react'
import colors from '../../utils/colors'

const ButtonSort = ({children, active, className, style, onClick}) => {
  return (
    <button
      className={`bg-white border rounded rounded-md text-center p-2 px-4 text-sm ${className}`}
      style={{
        borderColor: active ? colors.blue : '#ddd',
        ...style
      }}
      onClick={onClick}
    >
      <span className="text-gray-999">{children}</span>
    </button>
  )
}

export { ButtonSort }